import { makeGetSelectors } from "@/utils/redux/selector";
import { AUTH_STATE_KEY_LIST } from "@/redux/slices/auth";

export const { getIsAuthenticated } = makeGetSelectors("auth", AUTH_STATE_KEY_LIST);
